export default __webpack_public_path__ + "static/media/Upload_Cloud.9e29efa9.svg";